'use client';
import React, { useState, useEffect } from 'react';
import Homep from '@/app/componenets/Homep';
import { notFound } from 'next/navigation';
import Card from '@/app/locations/[CitiesPage]/cards';
import Section from '@/app/locations/[CitiesPage]/section1';
import Cities from '@/app/locations/[CitiesPage]/cities';
import TawkTo from '@/app/componenets/Tawko';
import MainData from '@/app/data/MainState';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page({ params }) {
  // console.log(MainData, params, "hellllllll");
  const [image, setImage] = useState('');
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const mapping = MainData?.find((p) => p?.link === params.CitiesPage);
  // console.log(mapping, "mapng");

  if (!mapping) {
    notFound(); // Ye Next.js ko 404 page dikhaane ke liye bolta hai
  }
  useEffect(() => {
    if (mapping) {
      const data = mapping?.data[0];
      setImage(data.hero_image);
      setTitle(data.title);
      setSubtitle(data.subtitle);
    }
  }, [mapping]);

  console.log(image, 'iiiii');

  return (
    <div>
      <title>
        {mapping?.data?.length > 0
          ? mapping.data[3].metaTitle
          : 'Prestige Ride | First-Class Black Car & Chauffeur Services'}
      </title>
      <meta
        name="description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[3].metaDescription
            : 'Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable.'
        }
      />

      {/* OG Tags */}
      <meta
        property="og:url"
        content={
          mapping?.data?.length > 0
            ? mapping.data[3].Link
            : 'https://www.prestigeride.com'
        }
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content={
          mapping?.data?.length > 0
            ? mapping.data[3].metaTitle
            : 'Prestige Ride | First-Class Black Car & Chauffeur Services'
        }
      />
      <meta
        property="og:description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[3].metaDescription
            : 'Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable.'
        }
      />
      <meta
        property="og:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      {/* Twitter Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="prestigeride.com" />
      <meta
        property="twitter:url"
        content={
          mapping?.data?.length > 0
            ? mapping.data[3].Link
            : 'https://www.prestigeride.com'
        }
      />
      <meta
        name="twitter:title"
        content={
          mapping?.data?.length > 0
            ? mapping.data[3].metaTitle
            : 'Prestige Ride | First-Class Black Car & Chauffeur Services'
        }
      />
      <meta
        name="twitter:description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[3].metaDescription
            : 'Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable.'
        }
      />
      <meta
        name="twitter:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      <meta name="robots" content="index, follow" />
      <meta
        name="keywords"
        content={mapping?.data?.length > 0 ? mapping.data[3].metaKeywords : ''}
      />
      <link
        rel="canonical"
        href={mapping?.data?.length > 0 ? mapping.data[3].Link : ''}
      />
      <TawkTo />
      <Navbar />
      <Homep image={image} title={title} subtitle={subtitle} />
      <Card Mydata={mapping?.data} />
      <Section Mydata={mapping?.data} />
      <Cities Mydata={mapping?.data} />
      <Footer />
    </div>
  );
}

export default page;
